<!-- Filter Bar -->
<div class="card mb-3 rounded-0 border-0 border-bottom">
  <div class="card-body">
    <div class="row g-3 align-items-end">
      <!-- Date Type -->
      <div class="col-auto">
        <label class="form-label fw-semibold">Filter By</label>
        <select class="form-select" [(ngModel)]="data.type" (change)="switchType()">
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="last7">Last 7 Days</option>
          <option value="last30">Last 30 Days</option>
          <option value="this_month">This Month</option>
          <option value="last_month">Last Month</option>
          <option value="week">Week</option>
          <option value="day">Day</option>
          <option value="custom">Custom Range</option>
        </select>
      </div>

      <!-- Week picker -->
      <div class="col-auto" *ngIf="data.type === 'week'">
        <label class="form-label fw-semibold">Select Week</label>
        <ng-select style="min-width:280px" bindLabel="label" bindValue="value" [items]="dates"
          [clearable]="false" [(ngModel)]="data.week_number"></ng-select>
      </div>

      <!-- Day picker -->
      <div class="col-auto" *ngIf="data.type === 'day'">
        <label class="form-label fw-semibold">Select Date</label>
        <input type="date" class="form-control" [max]="today" [(ngModel)]="data.date">
      </div>

      <!-- Custom Range -->
      <ng-container *ngIf="data.type === 'custom'">
        <div class="col-auto">
          <label class="form-label fw-semibold">From</label>
          <input type="date" class="form-control" [max]="today" [(ngModel)]="custom_from">
        </div>
        <div class="col-auto">
          <label class="form-label fw-semibold">To</label>
          <input type="date" class="form-control" [max]="today" [(ngModel)]="custom_to">
        </div>
      </ng-container>

      <!-- Search -->
      <div class="col-auto">
        <label class="form-label fw-semibold">Search Agent</label>
        <input type="text" class="form-control" placeholder="Name / Code" [(ngModel)]="search"
          (keyup.enter)="filter()">
      </div>

      <div class="col-auto">
        <button class="btn btn-primary" (click)="filter()" [disabled]="is_loading_logs">
          <span *ngIf="is_loading_logs" class="spinner-border spinner-border-sm me-1"></span>
          Search
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Summary Cards -->
<div class="row g-3 mb-3 px-2" *ngIf="filtered_logs.length > 0">
  <div class="col-6 col-md-2">
    <div class="card border-0 bg-primary text-white rounded-3">
      <div class="card-body py-3">
        <div class="small opacity-75">Total Agents</div>
        <div class="fs-4 fw-bold">{{ filtered_logs.length }}</div>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-2">
    <div class="card border-0 bg-success text-white rounded-3">
      <div class="card-body py-3">
        <div class="small opacity-75">Total Commission</div>
        <div class="fs-5 fw-bold">{{ configuration.currency }} {{ (sum('commission') + sum('rolling_commission')) | number:'1.3-3' }}</div>
        <div class="small opacity-75">
          W/L {{ sum('commission') | number:'1.2-2' }} + Rolling {{ sum('rolling_commission') | number:'1.2-2' }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-2">
    <div class="card border-0 rounded-3" style="background:#0d6efd22">
      <div class="card-body py-3">
        <div class="small text-muted">Total In (Deposit)</div>
        <div class="fs-5 fw-bold text-primary">{{ configuration.currency }} {{ sum('total_in') | number:'1.3-3' }}</div>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-2">
    <div class="card border-0 rounded-3" style="background:#dc354522">
      <div class="card-body py-3">
        <div class="small text-muted">Total Out (Withdraw)</div>
        <div class="fs-5 fw-bold text-danger">{{ configuration.currency }} {{ sum('total_out') | number:'1.3-3' }}</div>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-2">
    <div class="card border-0 rounded-3" [style.background]="sum('total_profit') >= 0 ? '#19875422' : '#dc354522'">
      <div class="card-body py-3">
        <div class="small text-muted">Total Profit</div>
        <div class="fs-5 fw-bold" [class.text-success]="sum('total_profit') >= 0" [class.text-danger]="sum('total_profit') < 0">
          {{ configuration.currency }} {{ sum('total_profit') | number:'1.3-3' }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-6 col-md-2">
    <div class="card border-0 bg-light rounded-3">
      <div class="card-body py-3">
        <div class="small text-muted">Period</div>
        <div class="fw-semibold small">{{ periodLabel() }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Table -->
<div class="card rounded-0" *ngIf="!is_loading_logs">
  <div class="card-body p-0">

    <div *ngIf="filtered_logs.length === 0" class="text-center py-5 text-muted">
      <div class="fs-5">No data found</div>
      <small>Try adjusting your filters or search</small>
    </div>

    <div class="table-responsive agent-report-scroll" *ngIf="filtered_logs.length > 0">
      <table class="table table-hover table-bordered mb-0 agent-report-table">
        <thead class="table-dark">
          <tr>
            <th style="width:40px">#</th>
            <th class="cursor-pointer" (click)="sortBy('code')">
              Code <span class="text-muted small">{{ sortIcon('code') }}</span>
            </th>
            <th class="cursor-pointer" (click)="sortBy('name')">
              Member <span class="text-muted small">{{ sortIcon('name') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('total_in')">
              In <span class="text-muted small">{{ sortIcon('total_in') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('total_out')">
              Out <span class="text-muted small">{{ sortIcon('total_out') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('total_profit')">
              Profit <span class="text-muted small">{{ sortIcon('total_profit') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('commission')">
              Commission <span class="text-muted small">{{ sortIcon('commission') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('rolling_commission')">
              Rolling 洗码 <span class="text-muted small">{{ sortIcon('rolling_commission') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('total_commission')">
              Total Paid 实付 <span class="text-muted small">{{ sortIcon('total_commission') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('total_wallet_withdraw')">
              Withdrawn <span class="text-muted small">{{ sortIcon('total_wallet_withdraw') }}</span>
            </th>
            <th class="text-center cursor-pointer" (click)="sortBy('withdraw_count')">
              # WD <span class="text-muted small">{{ sortIcon('withdraw_count') }}</span>
            </th>
            <th>WD Admin</th>
            <th class="text-end cursor-pointer" (click)="sortBy('wallet_balance')">
              Balance <span class="text-muted small">{{ sortIcon('wallet_balance') }}</span>
            </th>
            <th class="text-end cursor-pointer" (click)="sortBy('lifetime_profit')">
              Lifetime Profit <span class="text-muted small">{{ sortIcon('lifetime_profit') }}</span>
            </th>
            <th class="text-center" style="width:60px">Detail</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of filtered_logs; let i = index">
            <td class="text-muted small">{{ i + 1 }}</td>
            <td><span class="badge bg-secondary">{{ log.code || '-' }}</span></td>
            <td>{{ log.name || '-' }}</td>
            <td class="text-end small text-primary">{{ log.total_in | number:'1.3-3' }}</td>
            <td class="text-end small text-danger">{{ log.total_out | number:'1.3-3' }}</td>
            <td class="text-end fw-semibold" [class.text-success]="log.total_profit >= 0"
              [class.text-danger]="log.total_profit < 0">
              {{ log.total_profit | number:'1.3-3' }}
            </td>
            <td class="text-end fw-semibold" [class.text-success]="log.commission > 0"
              [class.text-muted]="log.commission == 0">
              {{ configuration.currency }} {{ log.commission | number:'1.3-3' }}
            </td>
            <td class="text-end" [class.text-success]="log.rolling_commission > 0"
              [class.text-muted]="!log.rolling_commission">
              {{ configuration.currency }} {{ (log.rolling_commission || 0) | number:'1.3-3' }}
            </td>
            <td class="text-end fw-bold">
              {{ configuration.currency }} {{ (log.total_commission != null ? log.total_commission : log.commission) | number:'1.3-3' }}
            </td>
            <td class="text-end" [class.text-warning]="log.total_wallet_withdraw > 0"
              [class.text-muted]="log.total_wallet_withdraw == 0">
              {{ log.total_wallet_withdraw | number:'1.3-3' }}
            </td>
            <td class="text-center">
              <span *ngIf="log.withdraw_count > 0" class="badge bg-warning text-dark">{{ log.withdraw_count }}</span>
              <span *ngIf="log.withdraw_count == 0" class="text-muted">-</span>
            </td>
            <td class="small">{{ log.withdraw_admins }}</td>
            <td class="text-end fw-bold" [class.text-success]="log.wallet_balance > 0">
              {{ configuration.currency }} {{ log.wallet_balance | number:'1.3-3' }}
            </td>
            <td class="text-end fw-semibold" [class.text-success]="log.lifetime_profit >= 0" [class.text-danger]="log.lifetime_profit < 0">
              {{ log.lifetime_profit | number:'1.3-3' }}
            </td>
            <td class="text-center">
              <a href="javascript:void(0)" class="btn btn-sm btn-outline-primary py-0"
                (click)="openDetail(detailModal, log)">View</a>
            </td>
          </tr>
        </tbody>
        <tfoot class="table-dark">
          <tr>
            <td colspan="3" class="fw-semibold">Total ({{ filtered_logs.length }} agents)</td>
            <td class="text-end fw-bold">{{ sum('total_in') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold">{{ sum('total_out') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold">{{ sum('total_profit') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold">{{ configuration.currency }} {{ sum('commission') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold">{{ configuration.currency }} {{ sum('rolling_commission') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold">{{ configuration.currency }} {{ sum('total_commission') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold">{{ sum('total_wallet_withdraw') | number:'1.3-3' }}</td>
            <td class="text-center fw-bold">{{ sum('withdraw_count') }}</td>
            <td></td>
            <td class="text-end fw-bold">{{ configuration.currency }} {{ sum('wallet_balance') | number:'1.3-3' }}</td>
            <td class="text-end fw-bold" [class.text-success]="sum('lifetime_profit') >= 0" [class.text-danger]="sum('lifetime_profit') < 0">{{ sum('lifetime_profit') | number:'1.3-3' }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="text-muted small text-end px-3 py-1" style="opacity:.5" *ngIf="configuration">UTC{{configuration.timezone || '+08:00'}}{{configuration.currency && configuration.currency !== 'none' ? ' · ' + configuration.currency : ''}}</div>
</div>

<!-- Loading Spinner -->
<div class="text-center py-5" *ngIf="is_loading_logs">
  <div class="spinner-border text-primary"></div>
  <p class="mt-2 text-muted">Loading agent reports...</p>
</div>


<!-- Detail Modal -->
<ng-template #detailModal let-modal>
  <div class="modal-header bg-dark text-white">
    <div>
      <h5 class="modal-title mb-0 fw-bold">Commission Detail</h5>
      <small class="opacity-75" *ngIf="selected_log">
        {{ selected_log.name }} &bull; {{ selected_log.date }}
      </small>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <!-- Loading -->
    <div *ngIf="is_loading_detail" class="text-center py-5">
      <div class="spinner-border text-primary"></div>
      <p class="mt-2 text-muted">Fetching breakdown...</p>
    </div>

    <ng-container *ngIf="!is_loading_detail && commissionDetail">

      <!-- Agent Info -->
      <div class="d-flex gap-3 mb-4 flex-wrap">
        <div class="border rounded px-3 py-2 bg-light">
          <small class="text-muted d-block">Agent</small>
          <span class="fw-semibold">{{ selected_log?.name }}</span>
        </div>
        <div class="border rounded px-3 py-2 bg-light">
          <small class="text-muted d-block">Code</small>
          <span class="fw-semibold">{{ selected_log?.code || '-' }}</span>
        </div>
        <div class="border rounded px-3 py-2 bg-light">
          <small class="text-muted d-block">Period</small>
          <span class="fw-semibold">{{ selected_log?.date }}</span>
        </div>
        <div class="border rounded px-3 py-2 bg-light">
          <small class="text-muted d-block">Wallet Balance</small>
          <span class="fw-semibold text-success">{{ configuration.currency }} {{ selected_log?.wallet_balance | number:'1.3-3' }}</span>
        </div>
        <div class="border rounded px-3 py-2" *ngIf="commissionDetail?.summary"
          [style.background]="commissionDetail.summary.total_profit >= 0 ? '#19875422' : '#dc354522'">
          <small class="text-muted d-block">Total Profit (Lifetime)</small>
          <span class="fw-semibold" [class.text-success]="commissionDetail.summary.total_profit >= 0" [class.text-danger]="commissionDetail.summary.total_profit < 0">
            {{ configuration.currency }} {{ commissionDetail.summary.total_profit | number:'1.3-3' }}
          </span>
        </div>
      </div>

      <!-- Per-day breakdown list -->
      <div *ngIf="commissionDetail.report?.detail?.length > 0">
        <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3 flex-wrap gap-2">
          <h6 class="fw-bold text-dark mb-0">How this commission was calculated</h6>
          <div class="btn-group btn-group-sm" role="group">
            <button type="button" class="btn" [class.btn-primary]="view_mode==='simple'"
              [class.btn-outline-primary]="view_mode!=='simple'" (click)="view_mode='simple'">
              Simple view 简易
            </button>
            <button type="button" class="btn" [class.btn-primary]="view_mode==='advanced'"
              [class.btn-outline-primary]="view_mode!=='advanced'" (click)="view_mode='advanced'">
              Advanced table 详细表格
            </button>
          </div>
        </div>

        <!-- SIMPLE VIEW: plain-language receipt, one card per day -->
        <div *ngIf="view_mode==='simple'">
          <p class="text-muted small mb-3">
            Read each day top to bottom — every line shows where the number comes from.
            逐行阅读，即可看懂佣金是怎么算出来的。
          </p>
          <ng-container *ngFor="let day of commissionDetail.report.detail">
            <ng-container *ngIf="calcReceipt(day) as r">
              <div class="calc-receipt card mb-3 shadow-sm" [class.border-danger]="r.finalNegative">
                <div class="card-header d-flex justify-content-between align-items-center py-2"
                  [class.bg-danger]="r.finalNegative" [class.text-white]="r.finalNegative" [class.bg-light]="!r.finalNegative">
                  <span class="fw-bold">{{ day.date }}</span>
                  <span class="fw-bold">
                    Commission 佣金:
                    {{ configuration.currency }} {{ r.final | number:'1.2-2' }}
                    <span class="ms-2 fw-normal small" *ngIf="day.rolling_commission">
                      + Rolling 洗码 {{ configuration.currency }} {{ day.rolling_commission | number:'1.2-2' }}
                      = {{ configuration.currency }} {{ (day.total_commission != null ? day.total_commission : r.final) | number:'1.2-2' }}
                    </span>
                  </span>
                </div>
                <div class="card-body p-0">
                  <table class="table table-sm mb-0 calc-receipt-table">
                    <tbody>
                      <tr *ngFor="let row of r.rows" [class.fw-bold]="row.strong || row.final"
                        [class.table-active]="row.strong" [class.receipt-final-row]="row.final">
                        <td class="op text-muted text-center">{{ row.op }}</td>
                        <td>
                          {{ row.label }}
                          <div class="text-muted small">{{ row.cn }}</div>
                        </td>
                        <td class="text-end text-nowrap"
                          [class.text-danger]="row.neg || (row.final && r.finalNegative)"
                          [class.text-success]="row.final && !r.finalNegative">
                          <ng-container *ngIf="row.isRate">{{ row.value | number:'1.0-2' }}%</ng-container>
                          <ng-container *ngIf="!row.isRate">
                            <span *ngIf="row.neg">(</span>{{ configuration.currency }} {{ row.value | number:'1.2-2'
                            }}<span *ngIf="row.neg">)</span>
                          </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngIf="r.note" class="alert alert-warning small m-2 mb-2 py-2">
                    <strong>Why? 为什么:</strong> {{ r.note }}
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <!-- ADVANCED VIEW: full raw number table (original) -->
        <div *ngIf="view_mode==='advanced'" class="table-responsive agent-report-scroll">
          <table class="table table-sm table-bordered table-hover align-middle agent-report-detail-table">
            <thead class="table-dark">
              <tr>
                <th>Date</th>
                <th class="text-end">Deposit</th>
                <th class="text-end">Withdraw</th>
                <th class="text-end">Bonus</th>
                <th class="text-end">Rolling Paid</th>
                <th class="text-end">Rolling Deduction</th>
                <th class="text-end">Bucket Deduction</th>
                <th class="text-end">Bonus Deduction</th>
                <th class="text-end">Prev B/F</th>
                <th class="text-end">Next B/F</th>
                <th class="text-end">Commission</th>
                <th class="text-end">Rolling 洗码</th>
                <th class="text-end">Total Paid 实付</th>
                <th>Formula</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let day of commissionDetail.report.detail">
                <tr>
                  <td class="fw-semibold">{{ day.date }}</td>
                  <td class="text-end text-success">
                    {{ configuration.currency }} {{ (day.breakdown?.report?.total_deposit || day.breakdown?.total_deposit || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end text-danger">
                    {{ configuration.currency }} {{ (day.breakdown?.report?.total_withdraw || day.breakdown?.total_withdraw || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end text-warning">
                    {{ configuration.currency }} {{ (day.breakdown?.report?.total_bonus || day.breakdown?.total_bonus || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end">
                    {{ configuration.currency }} {{ (day.breakdown?.total_rolling_paid || day.breakdown?.report?.total_rolling_paid || 0) | number:'1.3-3' }}
                    <span class="text-muted small" *ngIf="day.breakdown?.rolling_rate != null">(×{{ day.breakdown.rolling_rate }})</span>
                  </td>
                  <td class="text-end text-danger">
                    {{ configuration.currency }} {{ (day.breakdown?.rolling_deduction || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end text-danger">
                    {{ configuration.currency }} {{ (day.breakdown?.bucket_deduction || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end text-danger">
                    {{ configuration.currency }} {{ (day.breakdown?.bonus_deduction || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end" [class.text-danger]="(day.breakdown?.report?.agent_balance || day.breakdown?.agent_balance || 0) < 0">
                    {{ configuration.currency }} {{ (day.breakdown?.report?.agent_balance || day.breakdown?.agent_balance || 0) | number:'1.3-3' }}
                  </td>
                  <td class="text-end" [class.text-danger]="getNextBF(day) < 0">
                    {{ configuration.currency }} {{ getNextBF(day) | number:'1.3-3' }}
                  </td>
                  <td class="text-end fw-bold text-success">{{ configuration.currency }} {{ day.commission | number:'1.4-4' }}</td>
                  <!-- The per-bet rolling rebate is paid on agent_wallet ('Agent Commission'), NOT in
                       agent_report. Without this column the panel printed 0.0000 for days the agent app
                       showed a real payout (co14 W479213, 16-20 Aug = RM2.05). -->
                  <td class="text-end" [class.text-success]="day.rolling_commission > 0"
                    [class.text-muted]="!day.rolling_commission">
                    {{ configuration.currency }} {{ (day.rolling_commission || 0) | number:'1.4-4' }}
                  </td>
                  <td class="text-end fw-bold">
                    {{ configuration.currency }} {{ (day.total_commission != null ? day.total_commission : day.commission) | number:'1.4-4' }}
                    <div class="text-danger small" *ngIf="day.wallet_adjustment">
                      adj {{ (day.wallet_adjustment || 0) | number:'1.2-2' }}
                    </div>
                  </td>
                  <td>
                    <code class="small">{{ day.formula }}</code>
                    <div class="text-muted small">{{ agentFormulaText(day) }}</div>
                    <div *ngIf="day.breakdown?.deductions?.length" class="mt-1 d-flex flex-wrap gap-1">
                      <span class="text-muted small">Deductions:</span>
                      <span *ngFor="let d of day.breakdown.deductions" class="badge bg-light text-dark border">
                        {{ d.code || ('Agent ' + d.agent_id) }}: {{ d.amount | number:'1.3-3' }}
                      </span>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Commission Total (Selected Period) -->
      <div class="mt-4 p-3 rounded bg-dark text-white d-flex justify-content-between align-items-center">
        <div>
          <div class="small opacity-75">Period Commission ({{ selected_log?.date }})</div>
          <div class="small opacity-75">{{ commissionDetail.report?.detail?.length || 0 }} day(s) with records</div>
        </div>
        <div class="text-end">
          <div class="display-6 fw-bold text-white">
            {{ configuration.currency }} {{ (commissionDetail.report?.total_commission != null ? commissionDetail.report?.total_commission : commissionDetail.report?.commission) | number:'1.4-4' }}
          </div>
          <!-- Both streams, so this total reconciles line-by-line with the agent app / agent wallet. -->
          <div class="small opacity-75">
            Win/Loss 输赢 {{ configuration.currency }} {{ commissionDetail.report?.commission | number:'1.4-4' }}
            + Rolling 洗码 {{ configuration.currency }} {{ (commissionDetail.report?.rolling_commission || 0) | number:'1.4-4' }}
          </div>
          <div class="small text-warning" *ngIf="commissionDetail.report?.wallet_adjustment">
            Wallet adjustment 调整 {{ configuration.currency }} {{ commissionDetail.report?.wallet_adjustment | number:'1.2-2' }}
          </div>
        </div>
      </div>

      <!-- All-Time Agent Summary -->
      <div class="mt-4" *ngIf="commissionDetail.summary">
        <h6 class="fw-bold border-bottom pb-2 mb-3 text-dark">All-Time Agent Summary
          <small class="text-muted fw-normal ms-2" *ngIf="commissionDetail.summary.first_date">
            ({{ commissionDetail.summary.first_date }} to {{ commissionDetail.summary.last_date }})
          </small>
        </h6>
        <div class="row g-2">
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block">Total In (Deposit)</small>
              <span class="fw-bold text-primary">{{ configuration.currency }} {{ commissionDetail.summary.total_in | number:'1.3-3' }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block">Total Out (Withdraw)</small>
              <span class="fw-bold text-danger">{{ configuration.currency }} {{ commissionDetail.summary.total_out | number:'1.3-3' }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block">Total Profit</small>
              <span class="fw-bold" [class.text-success]="commissionDetail.summary.total_profit >= 0"
                [class.text-danger]="commissionDetail.summary.total_profit < 0">
                {{ configuration.currency }} {{ commissionDetail.summary.total_profit | number:'1.3-3' }}
              </span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block">Total Commission</small>
              <span class="fw-bold text-success">{{ configuration.currency }} {{ commissionDetail.summary.total_commission | number:'1.3-3' }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block">Total Withdrawn</small>
              <span class="fw-bold text-warning">{{ configuration.currency }} {{ commissionDetail.summary.total_withdraw | number:'1.3-3' }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block"># Withdrawals</small>
              <span class="fw-bold">{{ commissionDetail.summary.withdraw_count }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2 bg-light">
              <small class="text-muted d-block">Active Days</small>
              <span class="fw-bold">{{ commissionDetail.summary.total_days }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="border rounded text-center p-2" style="background:#19875422">
              <small class="text-muted d-block">Wallet Balance</small>
              <span class="fw-bold text-success fs-5">{{ configuration.currency }} {{ commissionDetail.summary.wallet_balance | number:'1.3-3' }}</span>
            </div>
          </div>
        </div>
      </div>

    </ng-container>

    <!-- No data -->
    <div *ngIf="!is_loading_detail && !commissionDetail" class="text-center py-5 text-muted">
      No commission records found for this period.
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>
